// eslint-disable-next-line import/prefer-default-export
export const ShiftSegmentType = Object.freeze({
    Regular: 'REGULAR_SEGMENT',
    Break: 'BREAK_SEGMENT',
    Transfer: 'TRANSFER_SEGMENT',
});
